export default __webpack_public_path__ + "af590c4514e6634640794a173c981f1b.png";